import { Fragment, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'

interface ISideDrawerProps {
  open: boolean
  setOpen: (open: boolean) => void
  children: React.ReactNode
  title?: string | React.ReactNode
}

export default function SideDrawer({ open, setOpen, children, ...props }: any) {

  return (
    <>
      <Transition.Root show={open} as={Fragment as any}>
        {/* @ts-ignore - TypeScript compatibility issue with React 18 and HeadlessUI */}
        <Dialog as="div" className="relative z-10 " onClose={setOpen}>        
          <Transition.Child
            as={Fragment as any}
            enter="ease-in-out duration-500"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in-out duration-500"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            {/* @ts-ignore - TypeScript compatibility issue with React 18 and HeadlessUI */}
            <div className="fixed left-0 inset-0 backdrop-blur bg-opacity-75 transition-opacity mt-24" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-hidden">
            <div className="absolute inset-0 overflow-hidden">
              <div className="pointer-events-none fixed inset-y-0 left-0 flex max-w-full pr-10">
                <Transition.Child
                  as={Fragment as any}
                  enter="transform transition ease-in-out duration-500"
                  enterFrom="-translate-x-full"
                  enterTo="-translate-x-0"
                  leave="transform transition ease-in-out duration-500"
                  leaveFrom="translate-x-0"
                  leaveTo="-translate-x-full"
                >
                  {/* @ts-ignore - TypeScript compatibility issue with React 18 and HeadlessUI */}
                  <Dialog.Panel className="pointer-events-auto w-screen mt-20">
                    {/* @ts-ignore - TypeScript compatibility issue with React 18 and HeadlessUI */}
                    <div className="flex h-full flex-col flex-grow bg-sharp-darkglass shadow-xl p-6">
                      <>
                        {props.title && <Dialog.Title className="text-lg font-medium text-gray-900">
                          {props.title}
                        </Dialog.Title>}
                        
                        {children}
                      </>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  )
}
